const { fetchFourG } = require('api');
const { useQuery } = require('react-query');

const useFourGFetch = () => {
  return useQuery({
    queryKey: ['4g'],
    queryFn: fetchFourG,
  });
};
export default useFourGFetch;
